import { ExpiryStatus } from '../domain/ExpiryStatus';

export const formatLocalDateString = (date: string): string => {
	const isoDate = new Date(date);
	return formatDate(isoDate);
};

export const formatUTCDateString = (date: string): string => {
	const isoDateOnly = date.split("T")[0];
	return formatDate(new Date(isoDateOnly));
};

export const formatSameDayWithDayAndMonth = (date: string): string => {
	const isoDate = new Date(date);
	return isoDate
		.toLocaleDateString('en-GB', { month: '2-digit', day: '2-digit' })
		.replace(new RegExp('/', 'g'), '.');
};

export const formatPreviousDayWithDayAndMonth = (date: string): string => {
	const isoDate = new Date(date);
	isoDate.setDate(isoDate.getDate() - 1);
	return isoDate
		.toLocaleDateString('en-GB', { month: '2-digit', day: '2-digit' })
		.replace(new RegExp('/', 'g'), '.');
};

export const formatPreviousDayWithYear = (date: string): string => {
	const isoDate = new Date(date.replace(' ', '+'));
	isoDate.setDate(isoDate.getDate() - 1);
	return formatDate(isoDate);
};

export const formatPreviousDayForAriaLabel = (dateString: string): string => {
	const date = new Date(dateString);
	date.setDate(date.getDate() - 1);

	return date.toLocaleDateString('de-DE', {
		day: 'numeric',
		month: 'long'
	});
};

export const formatDate = (isoDate: Date): string => {
	return isoDate.toLocaleDateString('en-GB')
		.replace(new RegExp('/', 'g'), '.');
};

export const formatPreviousDayExpirationDate = (date: string): string => {
	const isoDate = new Date(date);
	isoDate.setDate(isoDate.getDate() - 1);
	return isoDate.toLocaleDateString('en-GB')
		.replace(new RegExp('/', 'g'), '.');
};

export const calculateExpirationStatus = (dateString: string): ExpiryStatus => {
	const date = new Date(dateString);
	const currentDate = new Date();

	const hoursToExpiration = (date.getTime() - currentDate.getTime()) / (1000 * 60 * 60);

	if (hoursToExpiration > 0 && hoursToExpiration < 24) {
		return ExpiryStatus.TODAY;
	} else if (hoursToExpiration >= 24 && hoursToExpiration < 48) {
		return ExpiryStatus.TOMORROW;
	} else if (hoursToExpiration >= 48) {
		return ExpiryStatus.LATER;
	} else {
		return ExpiryStatus.EXPIRED;
	}
};
